import * as React from 'react';
import Heading from '../../../components/heading/Heading';

const TypographyStyleGuide: React.FC<any> = () => (
  <>
    <hr />
    <Heading size="h2">Typography</Heading>
    <hr />
    <Heading size="h1">H1 Lorem ipsum dolor sit amet.</Heading>
    <Heading size="h3">H2 Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eos, perferendis?</Heading>
    <Heading size="h4">H3 Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minus, reprehenderit.</Heading>
    <Heading size="h4">H4 Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magnam, sed!</Heading>
    <Heading size="h5">H5 Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis, sequi?</Heading>
    <Heading size="h6">H6 Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolores, quae.</Heading>
    <hr />
  </>
);

export default TypographyStyleGuide;
